module.exports = __webpack_public_path__ + "assets/img/JID_Bulim Linear Park_RGB.853afb19.jpg";